function pluckJsonPath(obj, path) {
    if (obj === null || obj === undefined)
        return '';
    const parts = path.split('.');
    let current = obj;
    for (const part of parts) {
        if (current === null || current === undefined)
            return '';
        if (typeof current !== 'object')
            return '';
        current = current[part];
    }
    if (current === null || current === undefined)
        return '';
    return String(current);
}
export const HOST_FUNCTIONS = {
    'skarn.lookup': {
        capability: (args) => `skarn.read.${args[0] ?? ''}`,
        fn: async (args, ctx) => {
            const [product, entity, key, path] = args;
            if (!product || !entity || !key || !path)
                return '';
            const cacheKey = `lookup:${product}:${entity}:${key}:${path}`;
            const hit = ctx.cache.get(cacheKey);
            if (hit !== undefined)
                return hit;
            try {
                const record = await ctx.suiteClient.read(product, entity, key);
                const value = pluckJsonPath(record, path);
                ctx.cache.set(cacheKey, value);
                return value;
            }
            catch {
                return '';
            }
        },
    },
    'skarn.search': {
        capability: (args) => `skarn.read.${args[0] ?? ''}`,
        fn: async (args, ctx) => {
            const [product, entity, filterField, filterValue, path] = args;
            if (!product || !entity || !filterField || !filterValue || !path)
                return '';
            const cacheKey = `search:${product}:${entity}:${filterField}:${filterValue}:${path}`;
            const hit = ctx.cache.get(cacheKey);
            if (hit !== undefined)
                return hit;
            try {
                const records = await ctx.suiteClient.search(product, entity, filterField, filterValue);
                if (!Array.isArray(records) || records.length === 0) {
                    ctx.cache.set(cacheKey, '');
                    return '';
                }
                const value = pluckJsonPath(records[0], path);
                ctx.cache.set(cacheKey, value);
                return value;
            }
            catch {
                return '';
            }
        },
    },
};
//# sourceMappingURL=host-functions.js.map